/**
 * 线索规则配置
 * @author
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async findAll() {
        return request(api.clue.CLUERULECONFIG + "/findAll", METHOD.GET);
    },
    async fullSave(param) {
        return request(api.clue.CLUERULECONFIG + "/fullSave", METHOD.POST, param);
    },
}


export default {dataApi}